import { ArticleTileProps } from "shared/helpers/pageHelpers/Article/interface";
import { PodcastTileInterface } from "shared/helpers/pageHelpers/Podcast/interface";
import {
  ClassName,
  RecommendedTypes,
  VideoTileInterface,
} from "shared/helpers/pageHelpers/Common/interface";
import { ComponentProps } from "@/helpers/componentProps";

interface ContentInterface {
  type: RecommendedTypes;
  object: ArticleTileProps | PodcastTileInterface | VideoTileInterface;
}

export interface RecommendedContentInterface {
  data: ContentInterface[];
}

export enum RecommendedVariants {
  EmptyState = "emptyState",
}

export interface RecommendedInterface {
  data?: ContentInterface[];
  quantity?: number;
  variant?: RecommendedVariants;
  title?: string;
}

export interface RecommendedWrapperInterface extends ComponentProps {
  title?: string;
  className?: ClassName;
}
